// Recipe view state
import gql from 'graphql-tag';
import { graphql } from '../../utils/fetch';

const RECIPE_FRAGMENT =
  ` fragment recipeFields on Recipe {
      id
      name
      access
      categories
      link
      description
      ingredients
      directions
      prepTimeMin
      servings
    }
  `;

const state = {
  // The recipe to view
  recipe: null,
};

const getters = {
  recipe(s) {
    return s.recipe;
  },
};

const mutations = {
  recipe(s, r) {
    s.recipe = r;
  },
};

const actions = {
  fetchRecipe({ commit }, id) {
    return graphql.query({
      query: gql`query Recipe($id: ID!) {
        recipeById(id: $id) {
          ...recipeFields
        }
      }
      ${RECIPE_FRAGMENT}`,
      variables: {
        id,
      },
    })
    .then((response) => {
      if (!response.data.recipeById) {
        commit('recipe', null);
        throw new Error('Unknown recipe');
      }
      commit('recipe', response.data.recipeById);
      return response.data.recipeById;
    })
    .catch((err) => {
      commit('recipe', null);
      throw err;
    });
  },

  saveRecipe({ commit }, recipe) {
    return graphql.mutate({
      mutation: gql`mutation Recipe($recipe: RecipeInput!) {
        createRecipe(recipe: $recipe) {
          id
        }
      }`,
      variables: {
        recipe,
      },
    })
    .then((response) => {
      commit('notify', {
        message: 'Recipe created',
        type: 'is-success',
      }, { root: true });

      // TODO knowledge of 'foodItems' query should not be here
      graphql.localExtensions.invalidateStoreQuery('foodItems');
      return response.data.createRecipe.id;
    });
  },

  updateRecipe({ commit }, { id, recipe }) {
    return graphql.mutate({
      mutation: gql`mutation Recipe($id: ID!, $recipe: RecipeInput!) {
        updateRecipe(id: $id, recipe: $recipe) {
          ...recipeFields
        }
      }
      ${RECIPE_FRAGMENT}`,
      variables: {
        id,
        recipe,
      },
    })
    .then((response) => {
      if (!response.data.updateRecipe) {
        commit('recipe', null);
        throw new Error('Unknown recipe');
      }

      commit('notify', {
        message: 'Recipe updated',
        type: 'is-success',
      }, { root: true });

      // TODO knowledge of 'foodItems' query should not be here
      graphql.localExtensions.invalidateStoreQuery('foodItems');
      return response.data.updateRecipe;
    })
    .catch((err) => {
      commit('recipe', null);
      throw err;
    });
  },

  deleteRecipe({ commit }, id) {
    return graphql.mutate({
      mutation: gql`mutation Recipe($id: ID!) {
        deleteRecipe(id: $id) {
          ...recipeFields
        }
      }
      ${RECIPE_FRAGMENT}`,
      variables: {
        id,
      },
    })
    .then((response) => {
      if (!response.data.deleteRecipe) {
        throw new Error('Unknown recipe');
      }

      commit('recipe', null);

      commit('notify', {
        message: 'Recipe deleted',
        type: 'is-success',
      }, { root: true });

      // TODO knowledge of 'foodItems' query should not be here
      graphql.localExtensions.invalidateStoreQuery('foodItems');
    })
    .catch((err) => {
      throw err;
    });
  },
};

export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/recipe.js